(function () {
  'use strict';

  var rootSelector = '#mobile_menu';
  var toggleSelector = '[data-mobile-submenu-toggle]';
  var submenuSelector = '[data-mobile-submenu]';
  var initializedButtons = new WeakSet();

  function directSubmenu(item) {
    if (!item) return null;

    return Array.prototype.find.call(item.children, function (child) {
      return child.matches && child.matches(submenuSelector);
    }) || null;
  }

  function elementsWithId(id) {
    if (!id) return [];

    return Array.prototype.filter.call(document.querySelectorAll('[id]'), function (element) {
      return element.getAttribute('id') === id;
    });
  }

  function uniqueSubmenuId(submenu) {
    var current = submenu.getAttribute('id');
    var currentOwners = elementsWithId(current);
    if (currentOwners.length === 1 && currentOwners[0] === submenu) return current;

    var base = current ? current + '-mobile' : 'ch-mobile-submenu';
    var candidate = base;
    var suffix = 1;
    while (elementsWithId(candidate).length > 0) {
      suffix += 1;
      candidate = base + '-' + suffix;
    }

    submenu.setAttribute('id', candidate);
    return candidate;
  }

  function itemTitle(button, item) {
    var declared = button.getAttribute('data-mobile-submenu-title');
    if (declared && declared.trim()) return declared.trim();

    var title = item.querySelector('.mobile-menu-item-row > a [data-nav-title]');
    return title ? title.textContent.trim() : 'esta sección';
  }

  function setState(button, submenu, expanded, title, animate) {
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.setAttribute('aria-label', (expanded ? 'Cerrar' : 'Abrir') + ' submenú de ' + title);
    button.classList.toggle('active', expanded);

    var $submenu = window.jQuery ? window.jQuery(submenu) : null;
    if ($submenu) $submenu.stop(true, true);

    if (!animate || !$submenu) {
      submenu.setAttribute('data-mobile-submenu-open', expanded ? 'true' : 'false');
      submenu.hidden = !expanded;
      submenu.style.removeProperty('display');
    } else {
      if (expanded) {
        submenu.setAttribute('data-mobile-submenu-open', 'true');
        submenu.hidden = false;
        $submenu.hide().slideDown(200, function () {
          submenu.setAttribute('data-mobile-submenu-open', 'true');
          submenu.hidden = false;
          submenu.style.removeProperty('display');
        });
      } else {
        $submenu.slideUp(200, function () {
          submenu.setAttribute('data-mobile-submenu-open', 'false');
          submenu.hidden = true;
          submenu.style.removeProperty('display');
        });
      }
    }
  }

  function initializeToggle(button) {
    if (initializedButtons.has(button)) return;

    var item = button.closest('li.sublink');
    var submenu = directSubmenu(item);
    if (!submenu) return;

    var title = itemTitle(button, item);
    var submenuId = uniqueSubmenuId(submenu);

    button.setAttribute('aria-controls', submenuId);
    button.setAttribute('data-mobile-submenu-ready', 'true');
    submenu.hidden = true;
    setState(button, submenu, false, title, false);
    initializedButtons.add(button);
  }

  function initialize(root) {
    if (!root) return;
    root.querySelectorAll(toggleSelector).forEach(initializeToggle);
  }

  function reset(root) {
    if (!root) return;
    root.querySelectorAll(toggleSelector).forEach(function (button) {
      var item = button.closest('li.sublink');
      var submenu = directSubmenu(item);
      if (!submenu) return;

      setState(button, submenu, false, itemTitle(button, item), false);
    });
  }

  function start() {
    var root = document.querySelector(rootSelector);
    if (!root) return;
    if (document.__chagualMobileSubmenuController) return;
    document.__chagualMobileSubmenuController = true;

    initialize(root);

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest(toggleSelector) : null;
      if (!button) return;

      var liveRoot = button.closest ? button.closest(rootSelector) : null;
      if (!liveRoot || liveRoot !== document.querySelector(rootSelector)) return;

      event.preventDefault();
      event.stopPropagation();
      initializeToggle(button);

      var item = button.closest('li.sublink');
      var submenu = directSubmenu(item);
      if (!submenu) return;

      var expanded = button.getAttribute('aria-expanded') !== 'true';
      setState(button, submenu, expanded, itemTitle(button, item), true);
    }, true);

    var drawer = root.closest('[data-mobile-menu]');
    if (drawer) {
      drawer.addEventListener('chagual:mobile-menu-close', function () {
        reset(document.querySelector(rootSelector));
      });
      drawer.addEventListener('toggle', function () {
        if (!drawer.open) reset(document.querySelector(rootSelector));
      });

      new MutationObserver(function () {
        initialize(document.querySelector(rootSelector));
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
